export var dataDate = undefined;

export const setDataDate = (date) => {
  dataDate = date;
};

export const getDataDate = () => {
  return dataDate;
};
